import lang from '@/lang'
import React from 'react'
import { Route } from 'react-router'

const Company = React.lazy(() => import('@/modules/company/company'))
const MyAccountView = React.lazy(() => import('./view/my-account-view'))
const LetterPaperSettings = React.lazy(() => import('@/modules/letter-paper-settings/letter-paper-settings'))
const CustomerCenterSettings = React.lazy(() => import('./components/customer-center/customer-center-settings'))
const InterfacesView = React.lazy(() => import('./view/interfaces-view'))
const MasterDataView = React.lazy(() => import('./view/master-data-view'))
const CustomFieldList = React.lazy(() => import('@/modules/custom-fields/components/custom-field-list'))
const MoreSettingsView = React.lazy(() => import('./view/more-settings-view'))
const EventLogView = React.lazy(() => import('./view/event_log_view'))
const ChartOfAccountsList = React.lazy(() => import('@/modules/settings/components/tax-settings/chart-of-accounts/list/chart-of-accounts-list'))
const ElectronSetting = React.lazy(() => import('./components/electron/electron-setting'))
const MailboxSettingPage = React.lazy(() => import('./components/mailbox/mailbox-setting-page'))
const UserList = React.lazy(() => import('@/modules/user/components/list/user-list'))

const settingRoutes = (
  <>
    <Route path='settings/myaccount' Component={MyAccountView} />
    <Route path='settings/mycompany' Component={Company} />
    <Route path='settings/myoffice' Component={Company} />
    <Route path='settings/letter-paper' Component={LetterPaperSettings} />
    <Route path='settings/customer-center' Component={CustomerCenterSettings} />
    <Route path='settings/interfaces' Component={InterfacesView} />
    <Route path='settings/masterdata' Component={MasterDataView} />
    <Route path='settings/customFields' Component={CustomFieldList} handle={{ title: lang.settingDocumentTitles.customFields, options: { noBackgroundColor: true } }} />
    <Route path='settings/more-settings' Component={MoreSettingsView} />
    <Route path='settings/event-log' Component={EventLogView} />
    <Route path='settings/tax-settings/chart-of-accounts' Component={ChartOfAccountsList} />
    <Route path='settings/electron' Component={ElectronSetting} />
    <Route path='settings/mailbox' Component={MailboxSettingPage} />
    <Route path='users' Component={UserList} handle={{ title: lang.settingSectionTitles.user, options: { noBackgroundColor: true } }} />
  </>
)

export default settingRoutes
